import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/analytics/practice/hygiene-treatment')({ staticData: { team: 'analytics' } });
